import{palette as r}from"../../theme/units/palette.js";import{createStyles as t}from"../../theme/utils/create-styles.js";var e=t({root:{backgroundColor:r().background.paper}});export{e as styles};
